




























































































































































































































































import DateInput from "@/components/DateInput.vue";
import BankExtractImportItemsEdit from "../components/BankExtractImportItemsEdit.vue";
import SetIncorrectInvoice from "@/modules/invoiceFlow/components/SetIncorrectInvoice.vue";
import ValidationError from "@/modules/downPayment/components/ValidationError.vue";
import MoneyDisplay from "@/components/MoneyDisplay.vue";
import Confirmation from "@/components/Confirmation.vue";
import { ConfirmationMixin } from "@/mixins/confirmation";
import HeaderItem from "@/components/HeaderItem.vue";

import eventBus from "@/services/eventBus";
import store from "../services/BankExtractImportStore";
import invoiceStore from "@/modules/generalIngoingInvoice/services/GeneralIngoingInvoiceStore";

export default ConfirmationMixin.extend({
  components: {
    DateInput,
    SetIncorrectInvoice,
    BankExtractImportItemsEdit,
    ValidationError,
    MoneyDisplay,
    Confirmation,
    HeaderItem,
  },

  data: () => ({
    store,
    loaded: false,
    expanded: true,
    isLastDate: false,
    openBal: 0,
    openRate: 0,
    generatedDownPaymentInvoices: [] as Array<{ code: string; invoice: number }>,
  }),

  mixins: [ConfirmationMixin],

  async beforeMount() {
    this.store.reset();

    await Promise.all([
      this.store.load(Number(this.$route.params.headId)),
      this.store.loadItemTypes(),
      this.store.loadItemSubtypes(),
    ]);

    this.expanded = this.store.bankExtractImport.items.some((x) => x.expanded);
    this.loaded = true;
  },

  methods: {
    async prepareToImport() {

      if (this.store.bankExtractImport.items.some(x => x.typeID < 2))
      {
          const confirmed = await this.confirm(
            "Vannak olyan tételek, amelyeknek kitöltetlen a tétel típusa! Ezek a tételek nem adhatók fel! Biztosan folytatni akarja?"
          );
          if (!confirmed) return;
      }

      const checked = await this.store.prepareCheck();

      if (checked != "") {
        const confirm2 = await this.confirm(checked);
        if (!confirm2) return;
      }

      await this.store.update();
      await this.store.prepareToImport().then(async () => {
        await this.store.load(Number(this.$route.params.headId));
        eventBus.$emit("success", "Sikeres bemelésre előkészítés!");
      });
    },

    async update() {
      await this.store.update().then(async () => {
        await this.store.load(Number(this.$route.params.headId));
        eventBus.$emit("success", "Sikeres frissítés!");
      });
    },

    async setDeleted() {
      await this.store.setDeleted().then(async () => {
        await this.store.load(Number(this.$route.params.headId));
        eventBus.$emit("success", "Sikeres Törlés!");
      });
    },

    toggleExpanded() {
      this.expanded = !this.expanded;
      this.store.bankExtractImport.items.forEach((x) => (x.expanded = this.expanded));
    },

    async startImport() {
      this.isLastDate = await this.store.getIsLastDate();

      if (!this.isLastDate) {
        await this.importExtract();
      }
    },

    async importExtract(){
      this.isLastDate = false;

      await this.store.update();
      const result = await this.store.import(this.openBal, this.openRate);
      await this.store.load(Number(this.$route.params.headId));
      eventBus.$emit("success", "Sikeres beemelés!");
      this.setGeneratedDownPaymentInvoices(result);
    },

    setGeneratedDownPaymentInvoices(result: any) {
      this.generatedDownPaymentInvoices = (result?.stResults ?? [])
        .filter((x: any) => x.noto > 1 && x.code && x.invoice > 1)
        .map((x: any) => ({ code: x.code, invoice: x.invoice }));
    },

    viewGeneratedDownPaymentInvoices() {
      invoiceStore.invoiceFilter = this.generatedDownPaymentInvoices;
      this.$router.push("/invoice-browser/outgoing/filtered");
    },

  },

  computed: {
    disabled(): boolean {
      return this.store.bankExtractImport.cannotEdit;
    },

    errorMessage(): string {
      if (this.store.bankExtractImport.extract == "") return "A kivonat megadása kötelező!";

      if (this.store.bankExtractImport.items.some((x) => x.partnerID === 1)) return "Van kitöltetlen Partner!";

      return "";
    },
  },
});
